import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";

import { Section, SectionHeader } from "@roqua/components/sections";

import { PageTitle } from "@/components/PageTitle";
import { BackButton } from "@/components/ui/BackButton";
import { DeleteReport } from "@/features/Reports/show/DeleteReport";
import { DownloadActions } from "@/features/Reports/show/DownloadActions";
import { OpenInNewTabButton } from "@/features/Reports/show/OpenInNewTabButton";
import { PrintActions } from "@/features/Reports/show/PrintActions";
import { ReportQuery } from "@/features/Reports/show/queries";
import { ReportMetadata } from "@/features/Reports/show/ReportMetadata";
import { ReportViewer } from "@/features/Reports/show/ReportViewer";

export const Route = createFileRoute("/$organizationKey/$dossierId/reports/show/$reportId")({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  const { data } = useSuspenseQuery(ReportQuery, { variables: params });
  const report = data.dossier.report;

  return (
    <div>
      <PageTitle title="reportDetails" />
      <Section variant="header">
        <SectionHeader
          header={report.name}
          buttons={
            <>
              <BackButton />
              <DeleteReport reportId={report.id} />
            </>
          }
        />
        <ReportMetadata report={report} />
      </Section>
      <Section>
        <div className="flex flex-col gap-4">
          <div className="flex justify-end gap-4">
            <DownloadActions report={report} />
            <PrintActions report={report} />
            <OpenInNewTabButton report={report} />
          </div>

          <div className="col-span-3">
            <div className="rounded-lg border bg-white p-6">
              <ReportViewer report={report} />
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
}
